<template>
    <div class="is-mobile">
        <!--    <Report Builder History> -->
        <div class="column box bg" style="overflow-x:auto;">
            <div class="columns is-mobile">
                <div class="column">
                    <div class="field has-addons is-pulled-left">
                        <div class="control">
                            <p class="is-size-4" style="min-width: 300px;">Report Builder History</p>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field has-addons is-pulled-right">
                        <div class="control">
                            <input class="input is-normal input-width" type="text" v-model="searchText"
                                   placeholder="Search a Report Builder History">
                        </div>
                        <div class="control">
                            <a class="button">
                                <font-awesome-icon class="is-size-5 color-default" icon="search"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th title="ID Ipad Last Known Version On OCC">
                        <button class="t-sort"
                                @click="sortBy('IDIPADLKVOO')">IDIPADLKVOO
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'IDIPADLKVOO' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'IDIPADLKVOO')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('SignType')">SignType
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'SignType' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'SignType')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('PreparedLVC')">PreparedLVC
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'PreparedLVC' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'PreparedLVC')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('LegNo')">LegNo
                            <font-awesome-icon class="sort-icon" :class="sort === 'LegNo' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'LegNo')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildTryDTStart')">ReportBuildTryDTStart
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildTryDTStart' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildTryDTStart')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildTryDTFinish')">ReportBuildTryDTFinish
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildTryDTFinish' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildTryDTFinish')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('STDDay')">STDDay
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'STDDay' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'STDDay')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ALL_STAT')">ALL_STAT
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ALL_STAT' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ALL_STAT')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportTryCount')">ReportTryCount
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportTryCount' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportTryCount')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('AllCopyStatus')">AllCopyStatus
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'AllCopyStatus' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'AllCopyStatus')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildError')">ReportBuildError
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildError' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildError')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('WhichLocalPath')">WhichLocalPath
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'WhichLocalPath' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'WhichLocalPath')"/>
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody v-if="paginate && paginate.length">
                <template v-for="(report, index) in paginate">
                    <tr :key="report.ID + '_' +index" :class="!isToggleActived[report.ID] ? 'bg-default' : 'bg-white'">
                        <td @click="toggle(report.ID)">
                            <font-awesome-icon :icon="iconToggle(opened.includes(report.ID))" size=""/>
                        </td>
                        <td :class="sort === 'IDIPADLKVOO' ? 'bg-sort-selected' : 'bg-default'">{{ report.IDIPADLKVOO }}</td>
                        <td :class="sort === 'SignType' ? 'bg-sort-selected' : 'bg-default'">{{ report.SignType }}</td>
                        <td :class="sort === 'PreparedLVC' ? 'bg-sort-selected' : 'bg-default'">{{ report.PreparedLVC }}</td>
                        <td :class="sort === 'LegNo' ? 'bg-sort-selected' : 'bg-default'">{{ report.LegNo }}</td>
                        <td :class="sort === 'ReportBuildTryDTStart' ? 'bg-sort-selected' : 'bg-default'">{{
                            report.ReportBuildTryDTStart | longFormatFromDT
                            }}
                        </td>
                        <td :class="sort === 'ReportBuildTryDTFinish' ? 'bg-sort-selected' : 'bg-default'">{{
                            report.ReportBuildTryDTFinish | longFormatFromDT
                            }}
                        </td>
                        <td :class="sort === 'STDDay' ? 'bg-sort-selected' : 'bg-default'">{{report.STDDay | longFormatFromDT }}</td>
                        <td :class="sort === 'ALL_STAT' ? 'bg-sort-selected' : 'bg-default'">{{report.ALL_STAT }}</td>
                        <td :class="sort === 'ReportTryCount' ? 'bg-sort-selected' : 'bg-default'">{{ report.ReportTryCount }}</td>
                        <td :class="sort === 'AllCopyStatus' ? 'bg-sort-selected' : 'bg-default'">{{ report.AllCopyStatus }}</td>
                        <td class="last-error" style="word-wrap: break-word;max-width: 150px" :class="sort === 'ReportBuildError' ? 'bg-sort-selected' : 'bg-default'">

                            <span v-if="!readMoreBuildError[report.ID + '_' + index]">{{ report.ReportBuildError.slice(0,10) }}</span>
                            <button  @click="activeReadMore(report.ID + '_' + index)" v-if="!readMoreBuildError[report.ID + '_' + index] && report.ReportBuildError !== ''">.. read more</button>
                            <span v-if="readMoreBuildError[report.ID + '_' + index]" v-html="report.ReportBuildError"></span>
                        </td>
                        <td style="word-wrap: break-word;max-width: 150px" :class="sort === 'WhichLocalPath' ? 'bg-sort-selected' : 'bg-default'">
                            <span v-if="!readMoreBuildError[report.ID + '_' + index]">{{ report.WhichLocalPath.slice(0,10) }}</span>
                            <a v-if="!readMoreBuildError[report.ID + '_' + index] && report.WhichLocalPath !== ''" @click="activeReadMore(report.ID + '_' + index)">.. read more</a>
                            <span v-if="readMoreBuildError[report.ID + '_' + index]" v-html="report.WhichLocalPath"></span>
                        </td>
                    </tr>
                    <tr :key="report.ID" v-if="opened.includes(report.ID)">
                        <td colspan="13" class="table-center sub-table bg-white">
                            <table class="box child-table-d-table" style="padding: 8px;">
                                <thead>
                                <tr class="bg-default">
                                    <th class="color-default p-8px">IDIPADLKVOO</th>
                                    <th class="color-default p-8px">IdRec</th>
                                    <th class="color-default p-8px">FActionCode</th>
                                    <th class="color-default p-8px">SignType</th>
                                    <th class="color-default p-8px">PreparedLVC</th>
                                    <th class="color-default p-8px">HisDT</th>
                                    <th class="color-default p-8px">ReportTryCount</th>
                                    <th class="color-default p-8px">LegNo</th>
                                    <th class="color-default p-8px">ALL_STAT</th>
                                    <th class="color-default p-8px">ReportBuildTryDTStart</th>
                                    <th class="color-default p-8px">ReportBuildTryDTFinish</th>
                                    <th class="color-default p-8px">CopyLastError</th>
                                    <th class="color-default p-8px">WhichLocalPath</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="builderHistory in report.BuilderHistory" :key="builderHistory.ID">
                                <!-- <tr v-for="builderHistory in report.BuilderHistory" :key="builderHistory.ID"> -->
<!--                                <tr v-for="builderHistory in JSON.parse(report.BuilderHistory)" :key="builderHistory.ID">-->
                                    <td class="p-8px">{{ builderHistory.IDIPADLKVOO }}</td>
                                    <td class="p-8px">{{ builderHistory.IdRec }}</td>
                                    <td class="p-8px">{{ builderHistory.FActionCode }}</td>
                                    <td class="p-8px">{{ builderHistory.SignType }}</td>
                                    <td class="p-8px">{{ builderHistory.PreparedLVC }}</td>
                                    <td class="p-8px">{{ builderHistory.HisDT | longFormatFromDT }}</td>
                                    <td class="p-8px">{{ builderHistory.ReportTryCount }}</td>
                                    <td class="p-8px">{{ builderHistory.LegNo }}</td>
                                    <td class="p-8px">{{ builderHistory.ALL_STAT }}</td>
                                    <td class="p-8px">{{ builderHistory.ReportBuildTryDTStart | longFormatFromDT }}</td>
                                    <td class="p-8px">{{ builderHistory.ReportBuildTryDTFinish | longFormatFromDT }}</td>
                                    <td class="last-error" style="word-wrap: break-word;max-width: 150px" >

                                        <span v-if="!readMoreBuildError[builderHistory.ID + '_' + index]">{{ builderHistory.ReportBuildError.slice(0,10) }}</span>
                                        <button  @click="activeReadMore(builderHistory.ID + '_' + index)" v-if="!readMoreBuildError[builderHistory.ID + '_' + index] && builderHistory.ReportBuildError !== ''">.. read more</button>
                                        <span v-if="readMoreBuildError[builderHistory.ID + '_' + index]" v-html="builderHistory.ReportBuildError"></span>
                                    </td>
                                    <td style="word-wrap: break-word;max-width: 150px" >
                                        <span v-if="!readMoreBuildError[builderHistory.ID + '_' + index]">{{ builderHistory.WhichLocalPath.slice(0,10) }}</span>
                                        <a v-if="!readMoreBuildError[builderHistory.ID + '_' + index] && builderHistory.WhichLocalPath !== ''" @click="activeReadMore(builderHistory.ID + '_' + index)">.. read more</a>
                                        <span v-if="readMoreBuildError[builderHistory.ID + '_' + index]" v-html="builderHistory.WhichLocalPath"></span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <!--    </Report Builder History> -->
    </div>
</template>
<script>
    import { mapState} from "vuex";

    export default {
        name: "ReportHistory",
        data() {
            return {
                opened: [],

                searchText: "",
                tempSearch: "",

                reportBuilderHistory: "",

                resultCount: 0,
                currentPage: 1,
                pageRange: 3,
                itemsPerPage: 5,
                pageNavigationInfo: {},

                isToggleActived: [],
                readMoreBuildError: [],
                moreError: [],
                iconList: [
                    {
                        type: true,
                        icon: "plus",
                    },
                    {
                        type: false,
                        icon: "minus",
                    },
                    {
                        type: "default",
                        icon: "sort",
                    },
                    {
                        type: "asc",
                        icon: "sort-up",
                    },
                    {
                        type: "desc",
                        icon: "sort-down",
                    }
                ],
                sort: 'id',
                sortDir: 'default'
            }
        },
        methods: {
           // ...mapActions(["getHistoryBuilderSummary", "reportBuilderHistoryError"]),

            async getReportBuilderHistory() {
                try {
                    // this.reportBuilderHistoryData
                    // let list = await this.$store.dispatch("reportSummary/getHistoryBuilderSummary")
                    //this.reportBuilderHistory = JSON.parse(this.historySummary);
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on getReportBuilderHistory, "+ e.message, type: "error"});
                    // this.$store.dispatch('reportSummary/reportBuilderHistoryError', e.message);
                }
            },



            // JsonView2(value)
            // {
            //
            //     if(value == null || value =="")
            //     {
            //         return "";
            //     }
            //
            //     if (/^[\],:{}\s]*$/.test(value.replace(/\\["\\/bfnrtu]/g, '@').
            //     replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?/g, ']').
            //     replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
            //
            //         //the json is ok
            //         var obj = JSON.parse(value);
            //         alert("parse etti mi ?")
            //
            //         console.log(obj)
            //
            //         if(obj == null || obj =="")
            //         {
            //             return "??";
            //         }
            //
            //         var patt2 = /(\\")/g;
            //
            //
            //
            //
            //         if(obj.toString().includes("SubObjectName"))
            //         {
            //             obj.SubObjectName=  JSON.parse(obj.SubObjectName.toString().replace(patt2,"\"").replace(/[|]/gi,""))
            //         }
            //         if(obj.toString().includes("SubObjectName2"))
            //         {
            //             obj.SubObjectName2=  JSON.parse(obj.SubObjectName2.toString().replace(patt2,"\""))
            //         }
            //
            //         return obj;
            //     }else{
            //
            //         return value;
            //     }
            //
            //
            // },

            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                    this.isToggleActived[id] = false;

                } else {
                    this.opened.push(id)
                    this.isToggleActived[id] = true;
                }
            },

            iconToggle(opened) {
                if (!opened) {
                    return this.iconList.find(x => x.type === true).icon
                } else {
                    return this.iconList.find(x => x.type === false).icon
                }
            },
            setResultCount(count) {
                this.resultCount = count;
            },
            setCurrentPage(currentPage) {
                this.currentPage = currentPage;
            },
            setPage(pageNumber) {
                this.currentPage = pageNumber;
                this.buildPageNavigationInfo()
            },
            setReportBuilderHistory(list) {
                this.reportBuilderHistory = list;
            },
            buildPageNavigationInfo() {
                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);

                this.pageNavigationInfo = {
                    start: firstPage - 1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total: _total,
                }
            },
            sortBy(sortName) {
                if (sortName === this.sort) {
                    this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
                } else {
                    this.sortDir = 'asc';
                }
                this.sort = sortName;
            },
            iconSort(sort, name) {
                if (name === this.sort) {
                    return this.iconList.find(x => x.type === sort).icon
                } else {
                    return this.iconList.find(x => x.type === 'default').icon
                }
            },
            async fillsearchField() {
                if (this.searchText !== "")
                    setTimeout(() => this.tempSearch = this.searchText, 1000)
                else {
                    this.tempSearch = "";
                    this.searchText = "";
                }
            },
            activeReadMore(id) {
                const index = this.moreError.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                    this.readMoreBuildError[id] = false;

                } else {
                    this.opened.push(id)
                    this.readMoreBuildError[id] = true;
                }
            },

        },


        async created() {
            await this.getReportBuilderHistory();
            this.currentPage = 1;

            this.buildPageNavigationInfo();
        },
        computed: {

            ...mapState("reportsummary", ["historySummary"]),

            reportBuilderHistoryData: function ()
            {

                    if(this.historySummary === undefined || this.historySummary == [])
                    {
                        return [];
                    }
                    console.log("json1 json1 json1 json1 json1")
                    console.log(this.historySummary)
                    //var json1 =JSON.parse(this.historySummary)
                    console.log("json1 json1 json1 json1 json1")
                    //console.log(json1)
                    console.log("json2 json2 json2 json2 json2 json2")
                    var json2 = JSON.stringify(this.historySummary[0].BuilderHistory); // JSON.parse(this.historySummary.BuilderHistory)
                    console.log(json2)
                    json2 = JSON.parse(this.historySummary[0].BuilderHistory); // JSON.parse(this.historySummary.BuilderHistory)
                    console.log(json2)

                    // this.CalculateFlightCounts();
                    return this.historySummary;

            },

            totalPages() {
                return Math.ceil(this.resultCount / this.itemsPerPage);
            },

            paginate() {
                if (!this.historySummary) {
                    return
                }

                this.setReportBuilderHistory(this.historySummary);

                let list = this.reportBuilderHistory.filter((post) => {
                    return post.PreparedLVC.toString().match(this.searchText)
                        || post.WhichLocalPath.toLowerCase().match(this.searchText.toLowerCase())
                        || post.IDIPADLKVOO.toString().match(this.searchText);
                })
                this.setResultCount(list.length);
                if (this.currentPage === 0) this.setCurrentPage(1)
                if (this.currentPage >= this.totalPages) {
                    this.setCurrentPage(this.totalPages)
                }
                let index = this.currentPage * this.itemsPerPage - this.itemsPerPage


                this.buildPageNavigationInfo()
                return list.slice(index, index + this.itemsPerPage).sort((a, b) => {
                    let dir = (this.sortDir === 'asc') ? 1 : -1;
                    if (a[this.sort] < b[this.sort]) {
                        return -1 * dir;
                    } else if (a[this.sort] > b[this.sort]) {
                        return 1 * dir;
                    } else {
                        return 0;
                    }
                })
            },

        },
        mounted() {
        },
        watch: {
        }
    }
</script>
<style>


    .heading__credits .heading__link {
        color: inherit;
    }

    .btn-color {
        background-color: #6a85a7 !important;
        color: white;
    }

    .btn-color:hover {
        color: white;
    }

    .input-width {
        width: 15em;
    }


    .box:not(:last-child) {
        margin-bottom: 0.5rem;
    }

    .heading__credits .heading__link {
        color: inherit;
    }

    ol {
        margin: 0;
        padding: 0;
    }

    .child-table-d-table {
        display: table !important;
        width: 85%;
        background-color: white;
        pointer-events: auto!important;
    }

    li {
        list-style: none;
    }

    * {
        box-sizing: border-box;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
    }

    th {
        color: white !important;
    }
    th, td {
        text-align: left;
        padding: 8px 3px 8px 0;
    }

    .p-8px {
        padding: 5px;
    }

    thead tr:nth-child(1) {
        background-color: #6a85a7;
    }

    .box {
        color: #6a85a7;
    }


    .heading__credits .heading__link {
        color: inherit;
    }

    .bg {
        background-color: #f8f6ff;
    }

    .table-center {
        text-align: -webkit-center !important;
    }


    .t-sort {
        border: none;
        margin: 0;
        padding: 0;
        background: transparent;
        color: white;
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
    }

    .sort-icon {
        margin-left: 5px;
        font-size: 18px;
        color: #ffffff69;
    }

    .icon-color-white {
        color: #ffffff;
    }

    .icon-color-default {
        color: #ffffff69;
    }



    .bg-sort-selected {
        background-color: #eae7f3 !important;
    }

    .modal-card-size {
        min-height: calc(100vh - 40px);
        min-width: calc(200vh - 40px);
    }
    .delete {
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 25px;
        width: 25px;
    }

    tableFixHead table {
        background-color: #f8f6ff!important;
    }
    .modal-card-head {
        background-color: #f8f6ff!important;
    }
    .modal-card-title{
        color: #6a85a7!important;
    }
    .tableFixHead {
        height: calc(100vh - 150px);
        top: 0;
        width: 100%;
    }

    .tableOverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mr-10p {
        margin-right: 10px;
    }
    .btn-refresh {
        border: none;
        border-radius: 10px;
        font-size: 15px;
        cursor: pointer;
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 30px;
        width: 30px;
        background-color: #48c78e;
        color: #fff;
    }


</style>
